import { render, staticRenderFns } from "./PesquisaHorasSono.vue?vue&type=template&id=226c3d4d&scoped=true"
import script from "./PesquisaHorasSono.vue?vue&type=script&lang=js"
export * from "./PesquisaHorasSono.vue?vue&type=script&lang=js"
import style0 from "./PesquisaHorasSono.vue?vue&type=style&index=0&id=226c3d4d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226c3d4d",
  null
  
)

export default component.exports